import React, { useEffect, useState } from "react";
import { Nav, Tab } from "react-bootstrap";
import Select from "react-select";
import { fetchCoinsForSelect } from "../../../api/coin";

import P2PSellTab from "../Trading/P2P/P2PSellTab";
import BuyBthTable from "../Trading/P2P/BuyBthTable";
import SellBthTable from "../Trading/P2P/SellBthTable";

function Statement() {
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 574);

  useEffect(() => {
    fetchCoinsForSelect()
      .then((coins) => {
        console.log("COIN", coins);

        const mappedOptions = coins
          .filter((item) => item.coin && item.coin.symbol && item.coin.name)
          .map((item) => ({
            value: item.coin.id,
            label: `${item.coin.name} (${item.coin.symbol})`,
          }));

        setOptions(mappedOptions);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message || "Failed to load coins");
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 574);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <Tab.Container defaultActiveKey="Buy">
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-header border-0 d-flex justify-content-between align-items-center flex-wrap">
                <div className="d-flex flex-column" style={{ minWidth: 250 }}>
                  <h4 className="heading mb-2">Buy & Sell Statement</h4>
                  {loading && <p>Loading coins...</p>}
                  {error && <p style={{ color: "red" }}>{error}</p>}
                  {!loading && !error && (
                    <Select
                      options={options}
                      isMulti
                      value={selectedOptions}
                      onChange={setSelectedOptions}
                      placeholder="Select coins..."
                    />
                  )}{" "}
                </div>

                <Nav
                  className="order nav nav-tabs"
                  id="nav-tab-p2p"
                  role="tablist">
                  <Nav.Item>
                    <Nav.Link
                      eventKey="Buy"
                      className={isMobile ? "border rounded px-3 py-2" : ""}>
                      Buy
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link
                      eventKey="Sell"
                      className={isMobile ? "border rounded px-3 py-2" : ""}>
                      Sell
                    </Nav.Link>
                  </Nav.Item>
                </Nav>
              </div>
            </div>
          </div>

          <div className="col-xl-12">
            <div className="card">
              <div className="card-body">
                <Tab.Content>
                  <Tab.Pane eventKey="Buy">
                    <h4 className="heading">Buy</h4>
                    <BuyBthTable selectedCoins={selectedOptions} />
                  </Tab.Pane>
                  <Tab.Pane eventKey="Sell">
                    <h4 className="heading">Sell</h4>
                    {/* <P2PSellTab /> */}
                    <SellBthTable selectedCoins={selectedOptions} />
                  </Tab.Pane>
                </Tab.Content>
              </div>
            </div>
          </div>
        </div>
      </Tab.Container>
    </>
  );
}

export default Statement;
